module.exports = __webpack_public_path__ + "static/media/logo19.30df1335.jpg";